import PropTypes from 'prop-types';
import React from 'react';
import _ from 'lodash';

/**
* -Marker-
* Marker component
**/
export default class Marker extends React.Component {

	handleClick = (marker) => {

		// Custom click event
		if (this.props.onClick) {
			this.props.onClick(marker);
		}

		// InfoWindow
		if (this.props.content) {

			const content = this.props.content;

			const overlays = [{ content, marker }];

			this.props.addOverlay('sitewide', overlays);
		}
	}

	addMarker = () => {

		const { map, google, content, icon, label, visible } = this.props;

		const position = {
			lat: parseFloat(this.props.markerlocation.lat),
			lng: parseFloat(this.props.markerlocation.lng),
		}

		const title = this.props.title ? this.props.title : null;

		// Options
		const options = {
			map,
			position,
			title,
			icon,
			visible,
			optimized: content ? false : true, // false means overlay close clicks do not propagate, but have experienced markers not showing correctly, so if has content (infoWindow) then set to false
		};

		if (label) {

			const MarkerWithLabel = require('markerwithlabel')(google.maps);

			options.labelContent = label.labelContent;
			options.labelClass = label.labelClass;
			options.labelAnchor = label.labelAnchor;

			options.zIndex = 1000;

			this.marker = new MarkerWithLabel(options);

		} else {

			this.marker = new google.maps.Marker(options);
		}

		this.marker.addListener('click', _.debounce(() => this.handleClick(this.marker), 200));
	}

	updateMarker = () => {

		this.marker.setPosition(this.props.markerlocation);
		this.marker.setVisible(this.props.visible);
	}

	componentDidMount() {

		this.addMarker();
	}

	componentDidUpdate(prevProps) {

		const newLocation = !_.isEqual(this.props.markerlocation, prevProps.markerlocation);
		if (newLocation) {
			this.updateMarker();
		}

		const newVisible = !_.isEqual(this.props.visible, prevProps.visible);
		if (newVisible) {
			this.updateMarker();
		}
	}

	componentWillUnmount() {

		if (this.marker) {
			this.marker.setMap(null);
		}

		this.props.removeOverlay('sitewide');
	}

	render() {
		return null;
	}
}

Marker.propTypes = {
	markerlocation: PropTypes.object.isRequired,
	title: PropTypes.string,
	content: PropTypes.string,
	icon: PropTypes.object,
	label: PropTypes.object,
	onClick: PropTypes.func,
	visible: PropTypes.bool,
}

Marker.defaultProps = {
	visible: true,
}



// WEBPACK FOOTER //
// ./src/components/googlemaps/Marker.js